module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00222.01cc16c5.jpg";